import React from 'react';
import { Container, Text, Spacer } from '@nextui-org/react';
import BulkImport from '../../components/BulkImport';

const ImportPage: React.FC = () => {
    const handleImport = (data: any[]) => {
        console.log('Imported Data:', data);
        alert(`Successfully imported ${data.length} records!`);
    };

    return (
        <Container>
            <Spacer y={2} />
            <Text h2>Bulk Import</Text>
            <Text>Upload your data using the form below.</Text>
            <Spacer y={1} />
            <BulkImport
                requiredColumns={['Name', 'Email']}
                onSave={handleImport}
            />
        </Container>
    );
};

export default ImportPage;
